module.exports = __webpack_public_path__ + "static/img/case2.a0eaa2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/case2.png
// module id = HKiy
// module chunks = 1